import classnames from "classnames";
import parse, { domToReact } from "html-react-parser";
import PropTypes from "prop-types";
import React, { useContext } from "react";
// Components
import ContactDetailsBox from "../contact-details-box/ContactDetailsBox";
import { ContactDetailsContext } from "../../context/contact-details-context";

// Styles
import styles from "./contact-us-standard-solution.module.scss";

const getActiveContent = fields =>
  fields.find(
    ({ name, startDate, expirationDate }) =>
      name === "content" &&
      ((!startDate && !expirationDate) || new Date(startDate) < new Date() || new Date(expirationDate) > new Date()),
  ).content;

function ContactUsStandardSolution({ solution: { id, title, fields, buttonType, hierarchyPosition }, className }) {
  const { liveChatProminenceExperiment } = useContext(ContactDetailsContext);
  const locationOnPage = hierarchyPosition.join(" | ");

  return (
    <article className={classnames(styles.standardSolution, className)} data-solution-id={id}>
      <h2 className={styles.standardSolution__top}>Did you know...</h2>
      <div className={styles.standardSolution__inner} data-test="solution-inner">
        {title && <h2 data-test="solution-name">{title}</h2>}
        {parse(getActiveContent(fields), {
          replace: ({ type, name: tagName, attribs = {}, children }) =>
            type === "tag" && attribs && React.createElement(tagName, attribs, domToReact(children)),
        })}
        <ContactDetailsBox
          fields={fields.filter(({ name }) => ["phone", "chat-unavailable", "chat", "email"].includes(name))}
          buttonType={buttonType}
          solutionId={id}
          className={styles["standardSolution__contact-details"]}
          location={locationOnPage}
          title={liveChatProminenceExperiment ? "We’re here to help" : "Still need help?"}
          viewContactDetails
          showGreyBackground
        />
      </div>
    </article>
  );
}

ContactUsStandardSolution.propTypes = {
  solution: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        content: PropTypes.string,
      }),
    ),
    buttonType: PropTypes.string,
    hierarchyPosition: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  className: PropTypes.string,
};

ContactUsStandardSolution.defaultProps = {
  className: undefined,
};

export default ContactUsStandardSolution;
